import { I18N } from "./messages";

export const LANGS = [
  { code: "zh", name: "中文" },
  { code: "en", name: "English" },
  { code: "de", name: "Deutsch" },
  { code: "ko", name: "한국어" },
];

const STORAGE_KEY = "bf-lang";

export function getStoredLang() {
  try {
    const code = localStorage.getItem(STORAGE_KEY) || "zh";
    return I18N[code] ? code : "zh";
  } catch {
    return "zh";
  }
}

export function setStoredLang(code) {
  if (!I18N[code]) return;
  try {
    localStorage.setItem(STORAGE_KEY, code);
  } catch {
    /* ignore */
  }
}

export function createTranslator(lang) {
  const active = I18N[lang] ? lang : "zh";
  const tr = (key) => (I18N[active] && I18N[active][key]) ?? I18N.zh[key] ?? key;
  return { lang: active, tr, messages: I18N[active] };
}

export { I18N };
